import _find from 'lodash/find';
import _findIndex from 'lodash/findIndex';
import _remove from 'lodash/remove';
import _sortedIndexBy from 'lodash/sortedIndexBy';
import _toLower from 'lodash/toLower';
import addSchoolCommonRoomTemplate from './../add-school-common-room/add-school-common-room.html';
import editSchoolCommonRoomTemplate from './../edit-school-common-room/edit-school-common-room.html';
import template from './list-school-common-rooms.html';

class ListSchoolCommonRoomsComponent {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast, $timeout,
    SchoolCommonRoomService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.$timeout = $timeout;
    this.SchoolCommonRoomService = SchoolCommonRoomService;

    this.schedulePoints = [];
    this.tourExist = false;
    this.columnKeys = ['name'];
  }

  $onInit() {
    if (this.user.isAdmin) {
      this.columnKeys.push('id');
    }

    this.schoolCommonRoomsDisabled = this.schoolCommonRooms.filter(item => item.disabled);
    this.schoolCommonRoomsEnabled = this.schoolCommonRooms.filter(item => !item.disabled);
  }

  $onChanges(changes) {
    if (changes.user) {
      this.user = {...this.user};
    }

    if (changes.schoolCommonRooms) {
      this.schoolCommonRooms = Object.assign([], this.schoolCommonRooms);
    }
  }

  onTourReady(tour) {
    if (this.schoolCommonRooms.length === 0) {
      this.$timeout(() => {
        this.tourExist = true;
        tour.start();
      }, 100);
    }
  }

  onTourEnd() {
    this.tourExist = false;
  }

  addSchoolCommonRoom(ev) {
    if (this.tourExist) {
      return false;
    }

    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'AddSchoolCommonRoomController',
      template: addSchoolCommonRoomTemplate,
      disableParentScroll: true,
      clickOutsideToClose: true,
      targetEvent: ev
    })
      .then(newSchoolCommonRoom => {
        this.schoolCommonRoomsEnabled.splice(_sortedIndexBy(this.schoolCommonRooms, newSchoolCommonRoom, item => _toLower(item.name)), 0, newSchoolCommonRoom);
      });
  }

  edit(id, ev) {
    const schoolCommonRoom = this.getSchoolCommonRoom(this.schoolCommonRoomsEnabled, id);
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'EditSchoolCommonRoomController',
      template: editSchoolCommonRoomTemplate,
      locals: {schoolCommonRoom},
      disableParentScroll: true,
      clickOutsideToClose: true,
      targetEvent: ev
    })
      .then(editedSchoolCommonRoom => {
        const index = _findIndex(this.schoolCommonRoomsEnabled, item => item.id === editedSchoolCommonRoom.id);
        this.schoolCommonRoomsEnabled[index] = editedSchoolCommonRoom;
      });
  }

  editDisabled(id, ev) {
    const schoolCommonRoom = this.getSchoolCommonRoom(this.schoolCommonRoomsDisabled, id);
    this.$mdDialog.show({
      bindToController: true,
      controllerAs: 'ctrl',
      controller: 'EditSchoolCommonRoomController',
      template: editSchoolCommonRoomTemplate,
      locals: {schoolCommonRoom},
      disableParentScroll: true,
      clickOutsideToClose: true,
      targetEvent: ev
    })
      .then(editedSchoolCommonRoom => {
        const index = _findIndex(this.schoolCommonRoomsDisabled, item => item.id === editedSchoolCommonRoom.id);
        this.schoolCommonRoomsDisabled[index] = editedSchoolCommonRoom;
      });
  }

  disabled(id, ev) {
    ev.stopPropagation();
    const schoolCommonRoom = this.getSchoolCommonRoom(this.schoolCommonRoomsEnabled, id);
    schoolCommonRoom.disabled = true;
    this.SchoolCommonRoomService.edit(schoolCommonRoom)
      .then(() => {
        const idx = _findIndex(this.schoolCommonRooms, item => item.id === schoolCommonRoom.id);
        this.schoolCommonRooms[idx] = schoolCommonRoom;

        _remove(this.schoolCommonRoomsEnabled, item => item.id === id);
        this.schoolCommonRoomsDisabled.unshift(schoolCommonRoom);
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Wyłączono świetlicę')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  enabled(id, ev) {
    ev.stopPropagation();
    const schoolCommonRoom = {..._find(this.schoolCommonRoomsDisabled, item => item.id === id)};
    schoolCommonRoom.disabled = false;
    this.SchoolCommonRoomService.edit(schoolCommonRoom)
      .then(() => {
        const idx = _findIndex(this.schoolCommonRooms, item => item.id === schoolCommonRoom.id);
        this.schoolCommonRooms[idx] = schoolCommonRoom;
        _remove(this.schoolCommonRoomsDisabled, item => item.id === id);
        this.schoolCommonRoomsEnabled.unshift(schoolCommonRoom);
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Włączono świetlicę')
            .position('bottom right')
            .hideDelay(3000)
        );
      })
      .catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }

  remove(id, ev) {
    const confirm = this.$mdDialog.confirm()
      .title('Czy na pewno chcesz usunąć świetlicę?')
      .textContent('Wszystkie sale świetlicowe dodane do tej świetlicy zostaną usunięte (nie spowoduje to usunięcia sal z modułu sale szkolne). Usuniętej świetlicy nie będzie można przywrócić.')
      .ariaLabel('Usunięcie świetlicy')
      .targetEvent(ev)
      .ok('Usuń')
      .cancel('Zamknij');

    this.$mdDialog.show(confirm).then(() => {
      this.SchoolCommonRoomService.delete(id)
        .then(() => {
          _remove(this.schoolCommonRoomsEnabled, item => item.id === id);
          this.$mdToast.show(
            this.$mdToast.simple()
              .textContent('Usunięto świetlicę')
              .position('bottom right')
              .hideDelay(3000)
          );
        })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        });
    });
  }

  removeDisabled(id, ev) {
    const confirm = this.$mdDialog.confirm()
      .title('Czy na pewno chcesz usunąć świetlicę?')
      .textContent('Wszystkie sale świetlicowe dodane do tej świetlicy zostaną usunięte (nie spowoduje to usunięcia sal z modułu sale szkolne). Usuniętej świetlicy nie będzie można przywrócić.')
      .ariaLabel('Usunięcie świetlicy')
      .targetEvent(ev)
      .ok('Usuń')
      .cancel('Zamknij');

    this.$mdDialog.show(confirm).then(() => {
      this.SchoolCommonRoomService.delete(id)
        .then(() => {
          _remove(this.schoolCommonRoomsDisabled, item => item.id === id);
          this.$mdToast.show(
            this.$mdToast.simple()
              .textContent('Usunięto świetlicę')
              .position('bottom right')
              .hideDelay(3000)
          );
        })
        .catch(error => {
          this.$mdDialog.show(
            this.$mdDialog.extendError({
              locals: {error}
            })
          );
        });
    });
  }

  getSchoolCommonRoom(array, id) {
    return {..._find(array, item => item.id === id)};
  }

  loadDisabledSchoolCommonRooms() {
    if (this.showDisabled) {
      this.SchoolCommonRoomService.getAll(true)
        .then(result => {
          this.schoolCommonRoomsDisabled = result.filter(item => item.disabled);
        });
    }
  }
}

export const ListSchoolCommonRooms = {
  bindings: {
    user: '<',
    schoolCommonRooms: '<'
  },
  template,
  controller: ListSchoolCommonRoomsComponent
};
